// ActionButtons.js
import React from 'react';
import PropTypes from 'prop-types';
import EditIcon from '../../Assets/images/svg/dar_pencil.svg';
import DisabledEditIcon from '../../Assets/images/svg/dar_pencil_gray.svg';
import DeleteIcon from '../../Assets/images/svg/dar_delete.svg';
import DisabledDeleteIcon from '../../Assets/images/svg/dar_delete_gray.svg';
import UserCircleCheckIcon from '../../Assets/images/svg/user_circle_check.svg';
import DisabledUserCircleCheckIcon from '../../Assets/images/svg/user_circle_check_disabled.svg';
import CopyPasteIcon from '../../Assets/images/svg/copy.svg';
import DisabledCopyPasteIcon from '../../Assets/images/svg/copy_disabled.svg';

const ActionButtons = ({
  params,
  hasAccess,
  hasCloneAccess,
  hasResourceAccess,
  handleEditStaffAugStatusClick,
  handleCopyClick,
  handleRedirectToResource,
  handleDeleteClick,
}) => {
  const hasAnyPermission
    = hasResourceAccess('read')
    || hasResourceAccess('delete')
    || hasResourceAccess('update')
    || hasResourceAccess('create');

  return (
    <div className="staff-aug-action-buttons">
      <button
        disabled={!hasAccess('update')}
        aria-label="Edit"
        className={
          !hasAccess('update')
            ? 'staff-augmentation-action-icons-disabled'
            : 'staff-augmentation-action-icons'
        }
        onClick={() => handleEditStaffAugStatusClick(params.row)}
        id="staff-augmentation-action-icons"
      >
        <img
          src={!hasAccess('update') ? DisabledEditIcon : EditIcon}
          alt="Edit"
        />
      </button>

      <button
        id="staff-aug-copy-icon"
        aria-label="Copy"
        disabled={!hasCloneAccess('update')}
        className={
          !hasAccess('update')
            ? 'staff-augmentation-action-icons-disabled'
            : 'staff-augmentation-action-icons'
        }
        onClick={() => handleCopyClick(params.row)}
      >
        <img
          src={!hasCloneAccess('update') ? DisabledCopyPasteIcon : CopyPasteIcon}
          alt="Copy"
        />
      </button>

      <button
        id="staff-aug-request-resourcing-icon"
        disabled={!hasAnyPermission}
        onClick={() => handleRedirectToResource(params.row)}
        aria-label="Resouring"
        className="staff-augmentation-action-icons"
      >
        <img
          src={hasAnyPermission ? UserCircleCheckIcon : DisabledUserCircleCheckIcon}
          alt="Resourcing"
        />
      </button>

      <button
        id="staff-aug-delete-icon"
        disabled={!hasAccess('delete')}
        aria-label="Delete"
        className={
          !hasAccess('delete')
            ? 'staff-augmentation-action-icons-disabled'
            : 'staff-augmentation-action-icons'
        }
        onClick={() => handleDeleteClick(params.row)}
      >
        <img
          src={!hasAccess('delete') ? DisabledDeleteIcon : DeleteIcon}
          alt="Delete"
        />
      </button>
    </div>
  );
};

ActionButtons.propTypes = {
  params: PropTypes.shape({
    value: PropTypes.any,
    row: PropTypes.object.isRequired,
  }).isRequired,
  hasAccess: PropTypes.func.isRequired,
  hasCloneAccess: PropTypes.func.isRequired,
  hasResourceAccess: PropTypes.func.isRequired,
  handleEditStaffAugStatusClick: PropTypes.func.isRequired,
  handleCopyClick: PropTypes.func.isRequired,
  handleDeleteClick: PropTypes.func.isRequired,
  handleRedirectToResource: PropTypes.func.isRequired,
};

export default ActionButtons;
